import {userConstants} from '../../_constants';

export function listTypePayment(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_LIST_TYPE_PAYMENT_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_LIST_TYPE_PAYMENT_SUCCESS:
      return {
        loading: false,
        dataPayment: action.data,
        //...action.data,
      };
    case userConstants.GET_LIST_TYPE_PAYMENT_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
